import React, { Component } from 'react';
import { Box, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import PropTypes from "prop-types";

import logo from 'static/images/logo.png';

class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch() {
    return; // Would like to wire up some client-side logging at some point
  }

  render() {
    if (this.state.hasError || this.props.force) {
      let redirectPath = window.location.href.includes('webui')
        ? '../webui/'
        : '../';
      return (
        <Box sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <Box sx={{ textAlign: 'center', flex: 1 }}>
            <img src={logo} />
            <Box sx={{ marginTop: '20px' }}>
              <Typography sx={{ marginBottom: '16px' }}>
                Oh no, an error has occurred! Please try again, or contact <a href="https://www2.muellerreports.com/contact-us/" target="_blank">Technical Support</a> if the issue persists.
              </Typography>
              <Button onClick={() => window.location.replace(redirectPath)}>Home</Button>
            </Box>
          </Box>
        </Box>);
    } else {
      return this.props.children;
    }
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.object,
  force: PropTypes.bool,
};

export default ErrorBoundary;